import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_CLIENT_REQUEST_DATA = gql`
  query ClientRequestData($clientId: ID!) {
    client(id: $clientId) {
      id
      accounts {
        monthlyData {
          status
          yearMonth
        }
        name
        statementDayOfMonth
      }
      monthlyData {
        categorizeStatus
        month
      }
      yearlyData {
        cpaAdjustment
        trialBalanceOrPriorReturn
        year
      }
    }

    unifiedBankingEnabled: featureEnabled(id: $clientId, name: "unifiedBanking")
  }
`;
